<template>
  <div
    v-show="showCoupon"
    class="ljb-mask coupon"
    @touchmove.prevent>
    <div class="coupon-toast">
      <img
        :src= "couponImg"
        class="coupon-img"
        @click="getCoupon">
      <img
        class="close"
        src="https://cdn.51ljb.cn/close-coupon.png"
        @click.prevent="closeCoupon">
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupCoupon',
  props: {
    showCoupon: {
      type: Boolean,
      default: true
    },
    couponImg: {
      type: String,
      default: null
    }
  },
  data () {
    return {
    }
  },
  mounted () {

  },
  methods: {
    closeCoupon () {
      this.$emit('closeCoupon')
    },
    getCoupon () {
      this.closeCoupon()
      this.$emit('getCoupon')
    }
  }
}
</script>

<style lang="scss" scoped>
  .coupon {
    background-color: rgba(0, 0, 0, 0.6);
    .coupon-toast {
      text-align: center;
      position: absolute;
      width: 100%;
      top:10%;
      .coupon-img {
        width: 100%;
        height: auto;
        display: block;
        position: relative;
      }
      .close {
        position: absolute;
        top:80%;
        width: 32px;
        height: 32px;
        //left: 50%;
        margin-left: -16px;
        text-align: center;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/PopupCoupon.vue